import React, { useState, useEffect } from 'react';
import { Table, Popconfirm, message, Popover } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styled from '../../../shared/components/Style';
import FormSearch from './FormSearch';
import TableWrapper from '../../../shared/components/TableWrapper';

import axios from 'axios';
import {
  API_DELETE_ANNOUNCEMENT_STATUS,
  API_FEATURE_ANNOUNCEMENT,
} from '../../../shared/constant/url';
import { getAuthHeader, getError, header } from '../../../shared/utils';
import { render } from '@testing-library/react';
import { GENERAL } from '../../general/action';
import { INFO } from '../../info-operation/action';
import { BsFillPencilFill } from 'react-icons/bs';
const TableAnnouncement = (props) => {
  const [id, setId] = useState('');
  const dispatch = useDispatch();
  const {
    loading,
    listAnnouncement,
    getAnnouncementList,
    updateAnnouncementStatus,
    refreshData,
    searchData,
  } = props;

  const columns = [
    {
      title: 'Announcement Title',
      dataIndex: 'title',
      key: 'id',
    },
    {
      title: 'Date Posted',
      dataIndex: 'date_posted',
      key: 'id',
      render: (data, rowData) => renderDatePosted(rowData),
    },
    {
      title: 'Posted By',
      dataIndex: 'posted_by',
      key: 'id',
    },
    {
      title: 'Featured',
      dataIndex: 'status',
      key: 'id',
      render: (data, rowData) => renderStatus(rowData),
    },
    {
      title: 'Action',
      dataIndex: 'x',
      key: 'x',
      render: (data, rowData) => renderAction(rowData),
    },
  ];

  const renderDatePosted = (data) => {
    return <p>{data.created?.string}</p>;
  };

  const renderStatus = (data) => {
    switch (data.status) {
      case 'featured':
        return (
          <p
            style={{
              ...styled.approved,
              padding: '5px',
              width: '125px',
              textTransform: 'uppercase',
            }}
          >
            Featured
          </p>
        );
        break;

      case 'not-featured':
        return (
          <p
            style={{
              ...styled.declined,
              padding: '5px',
              width: '125px',
              textTransform: 'uppercase',
            }}
          >
            Not Featured
          </p>
        );
        break;
    }
  };

  const feature = () => {
    let param = { status: 'featured' };
    dispatch(updateAnnouncementStatus(param, id, callback));
  };

  const unfeature = () => {
    let param = { status: 'unfeatured' };
    dispatch(updateAnnouncementStatus(param, id, callback));
  };

  // const menu = (
  //   <div className="flex flex-col">
  //     <button style={styled.approved} className="px-3" onClick={feature}>
  //       Feature
  //     </button>
  //     {/* <button style={styled.declined} onClick={unfeature}>Unfeature</button> */}
  //   </div>
  // );

  // // const onDeleteItem = (id) => {
  // //     dispatch(deleteCommunityAffair(id, callback))
  // // }

  // const renderDropdown = (data) => {
  //   if (data.status === "featured") {
  //     return <div></div>;
  //   } else {
  //     return (
  //       <Popover content={menu} trigger="click" placement="bottom">
  //         <button onClick={() => setId(data.id)}>
  //           <i style={styled.btn} className="fas fa-caret-down bg-green-10"></i>
  //         </button>
  //       </Popover>
  //     );
  //   }
  // };

  const callback = (response, error) => {
    let res = response.message;
    if (res === 'Request failed with status code 403') {
      message.error('You do not have the required authorization.');
    } else {
      refreshData();
      dispatch(getAnnouncementList());
    }
  };

  const onDeleteItem = (id) => {
    dispatch({ type: INFO.DELETE_START });
    let requestOption = {
      method: 'DELETE',
      headers: getAuthHeader(),
    };
    fetch(`${API_DELETE_ANNOUNCEMENT_STATUS}${id}`, requestOption)
      .then((response) => response.json())
      .then((response) => {
        callback(response);
        dispatch({
          type: INFO.DELETE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(error, getError(error));
        dispatch({ type: INFO.DELETE_ERROR, payload: error });
      });
    const headers = {
      headers: getAuthHeader(),
    };
  };
  const onFeature = (id, data) => {
    let requestOption = {
      method: 'PATCH',
      headers: header(),
    };

    fetch(`${API_FEATURE_ANNOUNCEMENT}${id}/feature`, requestOption)
      .then((response) => response.json())
      .then((response) => {
        console.log(response.data);
        refreshData();
        callback(response, null);
        dispatch({
          type: GENERAL.INFO_STATUS,
          payload: response.data,
        });
      })
      .catch((error) => {
        // callback(null, getError(error));
        dispatch({ type: GENERAL.LIST_INFO_ERROR, payload: error });
      });

    // const headers = {
    //   headers: getAuthHeader(),
    // };

    // axios
    //   .patch(`${API_FEATURE_ANNOUNCEMENT}${id}/feature`, {
    //     withCredentials: true,
    //     ...headers,
    //   })
    //   .then((res) => {
    //     if (res.status === 204) {
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  const renderAction = (data) => {
    // console.log(data);
    return (
      <div
        className='d-flex flex-row flex-nowrap align-items-center'
        style={{ gap: '1em' }}
      >
        {/* <Link to="/summary-report">
          <i style={styled.btn} className="far fa-eye bg-green-10"></i>
        </Link> */}
        <Link
          to={`/edit-announcement/${data.id}`}
          style={{ width: '2rem' }}
        >
          <BsFillPencilFill
            className=' py-2 px-1 rounded'
            color='white'
            size={35}
            style={{
              background: 'black',
              cursor: 'pointer',
            }}
          />
        </Link>
        <Popconfirm
          placement='top'
          title='Are you sure you want to archive this?'
          onConfirm={() => onDeleteItem(data.id)}
          okText='Yes'
          cancelText='No'
        >
          <button style={{ width: '2rem' }}>
            <i
              style={{ ...styled.btn, margin: '0', width: '100%' }}
              className='far fa-trash-alt bg-red-10'
            ></i>
          </button>
        </Popconfirm>
        {data.status === 'not-featured' && (
          <Popconfirm
            placement='top'
            title='Are you sure you want to feature this?'
            onConfirm={() => onFeature(data.id, data)}
            okText='Yes'
            cancelText='No'
          >
            <div
              style={{ width: '2rem' }}
              // onClick={(e) => handleFeature(id, data.status)}
            >
              <i
                style={{ ...styled.btn, margin: '0', width: '100%' }}
                className={`fas fa-book bg-green-10 `}
              ></i>
            </div>
          </Popconfirm>
        )}
      </div>
    );
  };

  // const renderFeatureButton = (status, id) => {
  //   let style;

  //   if (status == 'not-featured') {
  //     style = 'bg-green-10';
  //   } else {
  //     style = 'bg-red-10';
  //   }

  //   return (
  //     <>
  //       {status == 'not-featured' ? (

  //       ) : (
  //         <></>
  //       )}
  //     </>
  //   );
  // };

  const handleFeature = (id, status) => {
    if (status == 'featured') {
      return;
    }

    let param = { status: 'featured' };
    dispatch(updateAnnouncementStatus(param, id, callback));
  };

  const renderRefresh = (value) => {
    searchData(value);
  };

  return (
    <div className='sub-container p-5'>
      <FormSearch getAnnouncementList={renderRefresh} />
      <TableWrapper>
        <Table
          loading={loading}
          // dataSource={allList}
          dataSource={listAnnouncement}
          columns={columns}
          scroll={{ x: 1000 }}
        />
      </TableWrapper>
    </div>
  );
};

export default TableAnnouncement;
